module.exports = __webpack_public_path__ + "assets/zhongqiujie.facf39e1.svg";